export const Timings = {
  LoadingTimeout: 500,
};
